<template>
  <div>
    <Nav></Nav>
    <b-container fluid class="mt-3">
      <b-row>
        <b-col>
          <h1>Existencias</h1>
        </b-col>
      </b-row>
      <b-row class="align-items-end">
        <b-col md="6">
          <b-form-group label="Almacén:" label-cols-md="3">
            <b-form-select
              v-model="selectedLocationId"
              :options="locationOptions"
              :disabled="locationsLoading"
              @change="getexistencias"
            ></b-form-select>
          </b-form-group>
        </b-col>
        <b-col md="auto">
          <b-button
            variant="success"
            size="sm"
            :disabled="!selectedLocationId || existenciasLoading"
            @click="getexistencias"
          >
            <b-spinner small v-if="existenciasLoading" class="mr-1"></b-spinner>
            Actualizar
          </b-button>
        </b-col>
      </b-row>
      <b-row v-if="selectedLocationId">
        <b-col>
          <b-form-group label="Buscar:">
            <b-form-input type="search" v-model="search" @keyup="page = 1" debounce="500"></b-form-input>
          </b-form-group>
        </b-col>
      </b-row>
      <b-row v-if="selectedLocationId">
        <b-col>
          <b-table
            small striped hover
            :filter="search"
            :items="existencias"
            :fields="existenciasLabels"
            :busy="existenciasLoading"
            responsive
          >
            <template #table-busy>
              <div class="text-center text-danger my-2">
                <b-spinner class="align-middle"></b-spinner>
                <strong>Loading...</strong>
              </div>
            </template>
            <template #empty>
              <div class="text-center text-muted my-2">Sin existencias en este almacén.</div>
            </template>
          </b-table>
        </b-col>
      </b-row>
      <b-row v-else>
        <b-col>
          <b-alert show variant="info" class="mb-0">
            Selecciona un almacén para cargar las existencias.
          </b-alert>
        </b-col>
      </b-row>
      <b-modal id="modal-newPurchaseOrder" :hide-footer="true" size="xl" title="Crear Orden de Compra">
      </b-modal>
    </b-container>

  </div>
</template>
<script>
import axios from "axios";
import Nav from "../components/Nav.vue";
export default {
  name: "Existencias",
  components: {
    Nav
  },

  data() {
    return {
      search: "",
      existencias: [],
      existenciasLoading: false,
      locations: [],
      locationsLoading: false,
      selectedLocationId: null,
      existenciasLabels: [
        { key: "location.complete_name", label: "Ubicacion" },
        { key: "supply.id", label: "ID" , sortable: true },
        { key: "supply.code", label: "Codigo" , sortable: true },
        { key: "supply.name", label: "Nombre" , sortable: true },
        { key: "quantity", label: "Inventario" , sortable: true },
        { key: "reserved_quantity", label: "Inventario Reservado" , sortable: true },
      ]
    };
  },

  computed: {
    locationOptions() {
      const opts = this.locations
        .filter(l => l.type_usage === "internal")
        .map(l => ({
          value: l.id,
          text: l.complete_name || l.name,
        }));
      return [{ value: null, text: "— Selecciona un almacén —" }, ...opts];
    }
  },
  mounted() {
    this.getLocations()
  },
  methods: {
    getLocations() {
      let that = this
      that.locationsLoading = true
      axios.get("/stocklocations")
        .then(function (res) {
          that.locations = res.data || []
        }).catch(function (err) {
          console.error(err)
          that.makeToast("danger", "Error", "No se pudieron cargar los almacenes")
        }).finally(function () {
          that.locationsLoading = false
        })
    },
    getexistencias() {
      if (!this.selectedLocationId) {
        this.existencias = []
        return
      }
      let that = this
      that.existenciasLoading = true
      axios.get("/stock/quantities", { params: { location_id: this.selectedLocationId } })
        .then(function (res) {
          that.existencias = (res.data || []).filter(x => x.quantity > 0 || x.reserved_quantity > 0)
        }).catch(function (err) {
          console.error(err)
          that.makeToast("danger", "Error", "No se pudieron cargar las existencias")
        }).finally(function () {
          that.existenciasLoading = false
        })
    },
    makeToast(variant = null, title = "", text = "") {
      this.$bvModal.msgBoxOk(text, {
        title: title,
        okVariant: variant,
        centered: true
      })
    },
  },
};
</script>
